<template>
  <div>
    <RevSkeleton
      v-if="withTitle"
      class="mb-32"
      height="32px"
      shape="rectangle"
      width="190px"
    />

    <RevSkeleton
      :aria-label="i18n(translations.loading)"
      class="max-md:hidden"
      height="370px"
      shape="rectangle"
      width="100%"
    />

    <RevSkeleton
      :aria-label="i18n(translations.loading)"
      class="md:hidden"
      height="306px"
      shape="rectangle"
      width="100%"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevSkeleton } from '@ds/components/Skeleton'

import translations from './ProductCardCarousel.translations'

const i18n = useI18n()

withDefaults(defineProps<{ withTitle: boolean }>(), { withTitle: true })
</script>
